import { motion } from "framer-motion";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer data-testid="footer-section" className="relative py-10 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <img src="/logo-hitmax.png" alt="HitMax" className="h-6 w-auto" />
        <p className="font-mono2 text-[10px] tracking-widest uppercase text-zinc-700 text-center">{t.footer.disclaimer}</p>
        <div className="flex items-center gap-4">
          <p className="font-mono2 text-[10px] tracking-widest uppercase text-zinc-600">{t.footer.legal}</p>
          <a href="/admin" data-testid="footer-admin-link" className="font-mono2 text-[10px] tracking-widest uppercase text-zinc-700 hover:text-[#CCFF00] transition-colors duration-300">Admin</a>
        </div>
      </div>
    </footer>
  );
}
